import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import GroupsEditForm from "./GroupEditForm";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";


function GroupsListItem({ id, text, companyId = false, open = false, close = null }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(open);
    const [name, setName] = useState(text);
    const availableLan = useGetAvailableLanguages();

    const handleOpen = (newName) => {
        setIsOpen(!isOpen);
        close && close(id);
        if (newName) setName(newName);
    };

    useEffect(() => {
        setIsOpen(open);
    }, [open]);

    return (
        <>
            {/**<div className="text-end small text-muted">{id}</div>**/}
            <div className="modulWrap mt-0" >
                {!isOpen ? (
                    <div onClick={() => handleOpen()} className="groupOverview-list">
                        {availableLan.map((lng, key) => (
                            <p key={key}>
                                <span key={lng}>
                                    <strong>{lng}: </strong>
                                    {name && name[lng]}
                                    {(name && !name[lng]) && <span className="noTranslation"></span>}
                                </span>
                            </p>
                        ))}
                        <button className="btn btn-default btn-edit" title={t("admin.common.edit")} />
                    </div>
                ) : (
                    <GroupsEditForm id={id} companyId={companyId} onClose={(newName) => handleOpen(newName)} />
                )}
            </div>
        </>
    );
}

export default GroupsListItem;


